module.exports = __webpack_public_path__ + "assets/img/type_5.6e6951e5.png";